export interface Ikryptomon extends IKryptomonResponse {
    extraMarketData?: IKryptomonSubgraph
    orders?: IKryptomonOrderSubgraph[]
    bids?: IBidSubgraph[]
    nextEvolution?: Date
    isReadyToEvolve?: boolean
    hatchingDate?: Date
    isReadyToHatch?: boolean
    trainedLevel?: number
}

export interface IKryptomonSubgraphQueryRes {
    data: {
        orders: IKryptomonOrderSubgraph[]
        kryptomons: IKryptomonSubgraph[]
        bids: IBidSubgraph[]
    }
    errors?: any
}

export interface IKryptomonSubgraph {
    tokenId: string
    timeCanBreed: string //in seconds
    breedingOrder: IBreedingOrder //TO CHECK
    breedingCount: string
    breedingsLeft: string
    activities: IKryptomonActivities[]
    owner: {
        address: string
    }
}

export interface IKryptomonOrderSubgraph {
    id: string
    tokenId: string
    price: string //Dollars
    createdAt: string
    expiresAt: string
    nftAddress: string
    status: | 'open' | 'sold' | 'cancelled'
    owner: string
    buyer: string
    paymentToken: | '0x0000000000000000000000000000000000000000' | '0xffffffffffffffffffffffffffffffffffffffff'
    nft: {
        contractAddress: string
    }
    updatedAt: string//date in second not in millsec
}

export interface IBidSubgraph {
    tokenId: string
    bidder: string
    price: string//in wei
    status: string//open
    expiresAt: string
    createdAt: string
    id: string
    paymentToken: string
    nftAddress: string
    blockchainId: string
    updatedAt: string//date in second not in millsec
    seller: string
}

export interface IKryptomonActivities {
    eventName: | 'birth' | 'evolution' | 'hatching' | 'breed' | 'sold' | 'transfer' | 'breed-as-matron' | 'addToBrededingCentre' | 'migration'
    date: string //Maybe in seconds not in milliseconds
    extraData: IActivityExtraData[]
}

export interface IActivityExtraData {
    label: string// for transfer | 'buyer' | 'seller'
    value: string //wallet address
}

export interface IBreedingOrder {
    price: string //Wei
    priceFloat: number //its evaluated in service
    // priceUSD?: number //its evaluated in Card
}

export interface IKryptomonResponse {
    tokenId: string
    matronId: string
    sireId: string
    timeBorn: string
    extraData: IextraData
    genesV1: Igenes
    name: string
    elementType: eElementType
    elementTalent: string
    elementPercentage: string
    elementTypeSecond: eElementType
    elementTalentSecond: string
    elementPercentageSecond: string
    speciality: eSpeciality
    id: string
    genes: Igenes
    status: number
    timeHatched: string
    rental: boolean
    startingDate?: any//TODO CHECK
    isStarter: boolean
    ranking: number
    type: | 'starter' | 'owned'
    babyRenderedStatus?: string//rendered
    juniorRenderedStatus?: string//rendered
    gameMetadata: IgameMetadata
}

export interface IgameMetadata {
    mainFamilyTalentPropertyName: number
    secondaryFamilyTalentPropertyName: number
    constitution: number
    hp: number
    attack: number
    defense: number
    mainFamilyTalentLevel: number
    secondaryFamilyTalentLevel: number
    constitutionLevel: number
    hpLevel: number
    attackLevel: number
    defenseLevel: number
    feedingGaugeAmount: number
    hapinessGaugeAmount: number
    healingGaugeAmount: number
    loveGaugeAmount: number
    isFreezed: number
    mainElementType: number
    secondaryElementType: number
}

export interface Igenes {
    // id: string
    // wallet: string






    affections: string
    air: string
    airTalent: string
    attack: string
    bodySize: string
    brave: string
    color: string
    constitution: string
    crazyness: string
    defense: string
    ego: string
    electro: string
    electroTalent: string
    fire: string
    fireTalent: string
    generalTalent: string
    generation: string
    ghost: string
    ghostTalent: string
    grass: string
    grassTalent: string
    ground: string
    groundTalent: string
    growthTalentFactor: string
    healthPoints: string
    hunger: string
    ice: string
    iceTalent: string
    instinct: string
    laziness: string
    sex: string
    skinType: string
    smart: string
    special: string
    speed: string
    water: string
    waterTalent: string
    xFactor: string










    // fire: string
    // fireTalent: string
    // water: string
    // waterTalent: string
    // ice: string
    // iceTalent: string
    // ground: string
    // groundTalent: string
    // air: string
    // airTalent: string
    // electro: string
    // electroTalent: string
    // ghost: string
    // ghostTalent: string
    // grass: string
    // grassTalent: string
    // color: string
    // sex: string
    // generalTalent: string
    // attack: string
    // defense: string
    // special: string
    // xFactor: string
    // growthTalentFactor: string
    // constitution: string
    // healthPoints: string
    // speed: string
    // affections: string
    // crazyness: string
    // instinct: string
    // hunger: string
    // laziness: string
    // brave: string
    // smart: string
    // bodySize: string
    // ego: string
    // skinType: string
    // generation: string
    // time_deleted_at?: string
    // status: string
    // last_evolution: string
    // migration_id: null
    // elementType: string
    // elementTalent: string
    // elementPercentage: string
    // elementTypeSecond: string
    // elementTalentSecond: string
    // elementPercentageSecond: string
    // speciality: string
    // created_at: string
    // timeHatched: string
    // name?: string

}

// export interface IBreedingSimulationData {
//     attack: number
//     defense: number
//     constitution: number
//     healthPoints: number
//     speed: number
//     affections: number
//     crazyness: number
//     instinct: number
//     hunger: number
//     brave: number
//     smart: number
//     ego: number
// }


export interface IElementTypeMainSecondInfo {
    elementType: eElementType
    elementTypeSecond: eElementType
    elementTalent: string
    elementTalentSecond: string
    elementPercentage: string
    elementPercentageSecond: string
}
export interface IextraData {
    unfreezable: string //as number
}

export enum eElementType {
    Fire = 'Fire',
    Air = 'Air',
    Grass = 'Grass',
    Ice = 'Ice',
    Electro = 'Electro',
    Ghost = 'Ghost',
    Ground = 'Ground',
    Water = 'Water'
}

export enum eSpeciality {
    Attack = 'Attack',
    Balance = 'Balance',
    Defense = 'Defense'
}

export enum eGender {
    female = 'female',
    male = 'male'
}
